import React, { useCallback, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { isNil, prop } from 'ramda'
import queryString from 'query-string'

import { useHealthCheck } from 'commons/useHealthCheck'
import { Routes } from 'app/services/routeService/routeService'
import PanelsIllustrationMSG from 'app/componentV4/Panels/IllustrationMSG'

import ResetPasswordV4 from './ResetPassword'
import ResetPasswordSuccess from './ResetPasswordSuccess'

const ResetPasswordPages = (props) => {
  const health = useHealthCheck()
  const params = queryString.parse(props.location.search, { decode: false })

  const code = prop('code', params)
  const email = prop('email', params)

  if (isNil(code)) {
    props.history.push(Routes.signIn())
  }

  const [isSuccess, setIsSuccess] = useState(false)

  const handleAhealtCheck = useCallback(async () => {
    await health.healtCheck.mutate()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    handleAhealtCheck()
  }, [handleAhealtCheck])

  return (
    <PanelsIllustrationMSG>
      <div className="flex justify-center items-center h-full">
        {isSuccess ? (
          <ResetPasswordSuccess />
        ) : (
          <ResetPasswordV4
            onSubmit={() => setIsSuccess(true)}
            {...props}
            params={{ code, email }}
          />
        )}
      </div>
    </PanelsIllustrationMSG>
  )
}

ResetPasswordPages.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  type: PropTypes.string.isRequired,
}

export default ResetPasswordPages
